import { ensureHeaderMicrofrontend } from '../../microfrontend';
import type { IOpenAuthModalParameters } from '../../../../../shared/types/microfrontends/headerFrontend';
import { authByEventsLogEvent } from '../../../../../shared/utils/auth';

/**
 * @description
 * Открывает модалку авторизации через runtime API микрофронта шапки.
 * Если шапка подключена легаси-разметкой (get-header-markup) и MF в реестре нет —
 * фолбэк на events-log событие `authenticate`.
 */
export async function openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void> {
  try {
    const microfrontend = await ensureHeaderMicrofrontend();

    if (microfrontend?.call) {
      return microfrontend.call('/v3/open-auth-modal/', parameters);
    }
  } catch {
    // header-frontend отсутствует в реестре — используем легаси events-log
  }

  authByEventsLogEvent(parameters);
}
